import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const standaloneWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.l,
  margin: "auto",
  padding: vars.space.xl,
  maxWidth: "400px",
  textAlign: "center",
});
